export default __webpack_public_path__ + "static/media/CMS_dashboard.a1adca7b.svg";